import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, Redirect, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import Icon from '../components/Icon'

import AccountSettings from './AccountSettings'
import NewSite from './NewSite'

const DefaultNavBar = (props) => <div>
  <div className='branding-logo' />
  <Link to='/dashboard/account' className='menu-item-right'>Account Settings</Link>
</div>

const AccountNavBar = () => <div>
  <Link to='/dashboard' className='menu-item-left'>
    <Icon name='ios-arrow-left' /> Back
  </Link>
  <h2 className='menu-title'>Account Settings</h2>
</div>

@connect(({ sites, auth }) => ({auth, sites: sites.sites}))
export default class Dashboard extends Component {
  static propTypes = {
    sites: PropTypes.array
  }

  // canAddSite = user.account && user.account.sites_available > 0
  // push('/new', {modal: true})

  render () {
    const {sites, auth, match} = this.props
    const canAddSite = auth.account && auth.account.sites_available > 0

    return <div className='dashboard'>
      <div className='dashboard-header'>
        <div className='container-wrapper'>
          <Switch>
            <Route path={`${match.url}/*`} component={AccountNavBar} />
            <Route component={DefaultNavBar} />
          </Switch>
        </div>
      </div>
      <div className='container-wrapper'>
        <Switch>
          <Route path='/dashboard/account' component={AccountSettings} />
          <Route exact path='/new' component={NewSite} />
          <Redirect path='/dashboard/upgrade' to='/dashboard/account/plan' />
          <Route render={() =>
            <div className='dashboard-fridges'>
              {sites.map(site =>
                <div key={site.id} className='fridge-item'>
                  <Link to={`/${site.id}`}>
                    <span className='name'>{site.name}</span>
                  </Link>
                </div>
              )}
              <div className='fridge-item create-new-fridge'>
                <Link to={canAddSite ? '/new' : '/dashboard/upgrade'}>
                  <span className='name'>
                    <Icon name='ios-plus-empty' />
                    New Fridge {!canAddSite && '(Upgrade)'}
                  </span>
                </Link>
              </div>
            </div>
          } />
        </Switch>
        {/* <ReactCSSTransitionGroup
          component='div' transitionName='push'
          transitionEnterTimeout={500} transitionLeaveTimeout={500}
        >
          {React.cloneElement(children || <div />, {key: pathname})}
        </ReactCSSTransitionGroup> */}
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/containers/Dashboard.js